import Vue from "vue";

Vue.mixin({
  data() {
    return {
      debouncedTimeouts: {},
    };
  },
  methods: {
    debounce: function(callback, id = "none", delay = 500) {
      if (this.debouncedTimeouts[id]) {
        clearTimeout(this.debouncedTimeouts[id]);
        delete this.debouncedTimeouts[id];
      }
      this.debouncedTimeouts[id] = setTimeout(callback, delay);
    },
  },
});
